// /sources/add — wizard route.

import { createRoute, useNavigate } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { AddSourceWizard } from "../sources/AddSourceWizard";

export const sourcesAddRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/sources/add",
  component: SourcesAdd,
});

function SourcesAdd() {
  const navigate = useNavigate();
  return (
    <AddSourceWizard
      onCancel={() => navigate({ to: "/sources" })}
      onCreated={(record) => navigate({ to: "/sources/$id", params: { id: record.id } })}
    />
  );
}
